// extracted by mini-css-extract-plugin
var _1 = "Undraggable__undraggable--QZHjt";
export { _1 as "undraggable" }
